var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitment11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_153127",
    "data-name": "\\uC0AC\\uAC01\\uD615 153127",
    width: 29,
    height: 29,
    transform: "translate(0 29) rotate(-90)",
    fill: "#05467e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitment11);
export default __webpack_public_path__ + "static/media/recruitment11.0df2b2bb0559685736f3ff0cbfd3fe10.svg";
export { ForwardRef as ReactComponent };